import React from 'react';
import { StyledPostsTabsContainer } from './PostTabs.styled';
import { Title, TitleSecondary } from 'assets/styles/theme';
import { T } from '@transifex/react';

interface PostsTabsProps {
  onTabClick: (tab: 'public' | 'private') => void;
  activeTab?: 'public' | 'private';
}

const PostsTabs: React.FC<PostsTabsProps> = ({ onTabClick, activeTab }) => {
  const isPublicTabSelected = activeTab === 'public';
  return (
    <StyledPostsTabsContainer>
      <button
        data-testid="profile?.showPublicPosts"
        onClick={() => onTabClick('public')}
        className={isPublicTabSelected ? 'active' : ''}
      >
        {isPublicTabSelected ? (
          <Title>
            <T _str="Public" />
          </Title>
        ) : (
          <TitleSecondary>
            <T _str="Public" />
          </TitleSecondary>
        )}
      </button>
      <button
        data-testid="profile?.activePostTab"
        onClick={() => onTabClick('private')}
        className={!isPublicTabSelected ? 'active' : ''}
      >
        {isPublicTabSelected ? (
          <TitleSecondary>
            <T _str="Private" />
          </TitleSecondary>
        ) : (
          <Title>
            <T _str="Private" />
          </Title>
        )}
      </button>
    </StyledPostsTabsContainer>
  );
};
export default PostsTabs;
